import { Constants } from '../../shared/Constants.js';

/**
 * Position and mount the popup shell for GenericDatepicker.
 * @returns {JQuery} the created container
 */
export function placePopup(picker) {
  const $ = window.jQuery;
  if (picker.$container) picker.$container.remove();

  const pos = picker.$input.offset();
  const height = picker.$input.outerHeight();
  const winWidth = $(window).width();
  const pickerWidth = Constants.PICKER_WIDTH;

  let left = pos.left;
  if (left + pickerWidth > winWidth) {
    left = winWidth - pickerWidth - Constants.SAFE_MARGIN;
    if (left < Constants.SAFE_MARGIN) left = Constants.SAFE_MARGIN;
  }

  let containerClasses = 'gdp-container gdp-core';
  if (picker.config.theme) {
    containerClasses += ` gdp-theme-${picker.config.theme}`;
  }

  return $(`<div class="${containerClasses}"></div>`)
    .css({
      top: pos.top + height + 5,
      left,
      position: 'absolute',
      zIndex: Constants.Z_INDEX,
    })
    .on('click mousedown', (e) => e.stopPropagation())
    .appendTo('body');
}
